import { z } from 'zod';

import { LanguageEnum } from '../../enums';
import { languageEnumValidator } from '../../validators';

export const GenerateCrosswordFromWordsSchema = z.object({
  words: z
    .array(
      z.object({
        translation: z.string().min(1),
        word: z.string().min(1),
      }),
    )
    .min(1, 'At least one word must be provided.'),
  gridSize: z.number().int().min(20).max(40).default(20),
  language: languageEnumValidator.default(LanguageEnum.RU),
});

export type IGenerateCrosswordFromWordsDto = z.infer<
  typeof GenerateCrosswordFromWordsSchema
>;
